import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/update-duck";

const { Types, Creators } = createActions(
  {
    request: ["id", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "DELETE_CARRIER_RESPONSIBLE_EMAIL_" }
);

export interface DeleteCarrierResponsibleEmailState extends IState {}

const INITIAL_STATE: DeleteCarrierResponsibleEmailState = {
  loading: false,
  error: null,
};

const request = (state: DeleteCarrierResponsibleEmailState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (
  state: DeleteCarrierResponsibleEmailState,
  action: ISuccessAction
) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (
  state: DeleteCarrierResponsibleEmailState,
  action: IFailureAction
) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const deleteCarrierResponsibleEmail = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const DeleteCarrierResponsibleEmailTypes = Types;
export const DeleteCarrierResponsibleEmailActions = Creators;
